import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HunaContainerOutPageComponent} from "./huna-container/huna-container-outPage.component";
import {TemplateFormComponent} from './template-form/template-form.component';
import {BoxProjectComponent} from './box-project/box-project.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {TranslateModule} from "@ngx-translate/core";
import {BoxDeviceComponent} from './box-device/box-device.component';
import {PipesModule} from "../providers/pipes/pipes.module";
import {MatIconModule} from "@angular/material/icon";
import {BoxThermostatComponent} from './box-thermostat/box-thermostat.component';
import {MatRippleModule} from "@angular/material/core";
import {MatSidenavModule} from "@angular/material/sidenav";
import {RouterModule} from "@angular/router";
import {LayoutModule} from "../components/layout/layout.module";
import {BoxElementComponent} from './box-element/box-element.component';
import {BoxIoTDeviceComponent} from './box-io-tdevice/box-io-tdevice.component';
import {
    BoxIotDevicesConfigurationComponent
} from './box-iot-devices-configuration/box-iot-devices-configuration.component';
import {BoxHeatPumpComponent} from './box-heat-pump/box-heat-pump.component';
import {BoxSensorEventComponent} from "./box-sensor-event/box-sensor-event.component";
import {WidgetModule} from "../widget/widget.module";
import {MatDividerModule} from "@angular/material/divider";
import { BoxActuatorsComponent } from './box-actuators/box-actuators.component';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTooltipModule} from "@angular/material/tooltip";
import { VerticalBoxElementComponent } from './vertical-box-element/vertical-box-element.component';
import { BoxIndustryMachinesComponent } from './box-industry-machines/box-industry-machines.component';
import {MatBadgeModule} from "@angular/material/badge";
import {DirectivesModule} from "../providers/directives/directives.module";
import {SensorDataIconPipe} from "../providers/pipes/sensor-data-icon.pipe";
import { GetElementByIdPipe } from '../pipes/get-element-by-id.pipe';


@NgModule({
    declarations: [HunaContainerOutPageComponent, TemplateFormComponent, BoxProjectComponent, BoxDeviceComponent, BoxThermostatComponent, BoxElementComponent, BoxIoTDeviceComponent, BoxIotDevicesConfigurationComponent, BoxHeatPumpComponent, BoxSensorEventComponent, BoxActuatorsComponent, VerticalBoxElementComponent, BoxIndustryMachinesComponent, GetElementByIdPipe],
    exports: [
        HunaContainerOutPageComponent,
        TemplateFormComponent,
        BoxProjectComponent,
        BoxDeviceComponent,
        BoxThermostatComponent,
        BoxElementComponent,
        BoxIoTDeviceComponent,
        BoxIotDevicesConfigurationComponent,
        BoxHeatPumpComponent,
        BoxSensorEventComponent,
        BoxActuatorsComponent,
        VerticalBoxElementComponent,
        BoxIndustryMachinesComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatGridListModule,
        TranslateModule,
        PipesModule,
        MatIconModule,
        MatButtonModule,
        MatRippleModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        RouterModule,
        LayoutModule,
        MatDialogModule,
        MatTooltipModule,
        WidgetModule,
        MatDividerModule,
        MatBadgeModule,
        DirectivesModule,
        SensorDataIconPipe,
    ]
})
export class BoxesModule {
}
